// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bi-report-container {
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  padding: 20px;
}

.bi-report-header {
  margin-bottom: 20px;
}

.bi-report-header h1 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.tab-navigation {
  display: flex;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
}

.bi-report-content {
  flex: 1 1;
  background-color: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.tab-button {
  flex: 1 1;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border: none;
  border-right: 1px solid #ddd;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
}

.tab-button:last-child {
  border-right: none;
}

.tab-button:hover {
  background-color: #e9ecef;
  color: #333;
}

.tab-button.active {
  background-color: #007bff;
  color: white;
  font-weight: 500;
}

.coming-soon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  font-size: 18px;
  color: #666;
  background-color: #f8f9fa;
}

/* TktsSLAsTable specific overrides */
.table-report-container .chart-container {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  padding: 10px;
}

/* Chart and Loading Styles */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  background-color: #f8f9fa;
}

.loading-spinner {
  font-size: 18px;
  color: #666;
  animation: pulse 1.5s ease-in-out infinite alternate;
}

@keyframes pulse {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  font-style: italic;
}

/* Responsive design */
@media (max-width: 1200px) {
  .table-report-container .report-card > div[style*="display: flex"] {
    flex-direction: column;
  }
  
  .table-report-container .report-card > div[style*="display: flex"] > div:first-child {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-right: 0;
  }
  
  .table-report-container .report-card > div[style*="display: flex"] > div:first-child > div {
    flex: 1 1;
    margin-right: 20px;
  }
}

/* SLA Plotly chart */
.sla-chart-section {
  background-color: white;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.sla-plotly-card {
  width: 100%;
  min-height: 700px;
  position: relative;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid #e3f2fd;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.sla-plotly-wrap {
  flex: 1 1;
  min-height: 600px;
  width: 100%;
}

.sla-chart-footer {
  margin-top: 16px;
  padding: 12px;
  background-color: #e3f2fd;
  border-radius: 6px;
  font-size: 11px;
  color: #495057;
  text-align: center;
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 16px;
}

.sla-chart-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 420px;
  background-color: #f8f9fa;
  border-radius: 12px;
  border: 2px dashed #dee2e6;
  margin: 20px 0;
  padding: 24px 16px;
}

.sla-chart-refresh-btn {
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sla-chart-refresh-btn:hover {
  background-color: #0056b3;
}

/* Resource effectiveness / bi-report shared mobile helpers */
.consultant-table-footer {
  padding: 16px 24px;
  background-color: #f8f9fa;
  border-top: 2px solid #495057;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.consultant-table-footer-stats {
  color: #495057;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.consultant-chart-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 20px;
}

.consultant-chart-modal {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 90vw;
  max-height: 90vh;
  width: 800px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: auto;
  box-sizing: border-box;
}

.consultant-chart-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
  gap: 12px;
}

.bi-split {
  display: flex;
  gap: 24px;
  padding: 0 24px;
}

.bi-split-aside {
  width: 280px;
  flex-shrink: 0;
}

.bi-table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

@media (max-width: 768px) {
  .bi-report-container {
    padding: 12px;
  }

  .bi-report-header h1 {
    font-size: 1.25rem;
  }

  .tab-navigation {
    flex-wrap: wrap;
  }

  .tab-button {
    padding: 8px 10px;
    font-size: 12px;
    flex: 1 1 45%;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 6px;
  }

  .sla-plotly-card {
    min-height: 0;
    padding: 12px;
    border-radius: 10px;
  }

  .sla-plotly-wrap {
    min-height: 320px;
    height: min(52vh, 380px);
  }

  .sla-chart-footer {
    font-size: 10px;
    text-align: left;
    justify-content: flex-start;
  }

  .sla-chart-empty {
    min-height: 280px;
    margin: 8px 0;
  }

  .consultant-table-footer {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 14px;
  }

  .consultant-table-footer-stats {
    gap: 8px 12px;
    width: 100%;
  }

  .consultant-chart-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .consultant-chart-modal {
    width: 100%;
    max-width: none;
    max-height: 92dvh;
    border-radius: 16px 16px 0 0;
    padding: 16px;
  }

  .consultant-chart-modal-header {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .consultant-chart-modal-header h3 {
    font-size: 1rem !important;
    word-break: break-word;
  }

  .consultant-chart-body {
    height: min(320px, 42vh) !important;
  }

  .resource-effectiveness-consultant-container .table-report-container .report-header,
  .resource-effectiveness-consultant-container .table-report-container [style*="padding: 0 24px"] {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .resource-effectiveness-consultant-container .report-header {
    padding: 14px 12px !important;
  }

  .bi-split {
    flex-direction: column;
    padding: 0 12px;
    gap: 16px;
  }

  .bi-split-aside {
    width: 100% !important;
  }

  .bi-split[style*="minHeight"] {
    min-height: 0 !important;
  }

  /* Override legacy inline bi-report flex sidebars on mobile */
  .table-report-container .report-card > div[style*="display: flex"] {
    flex-direction: column !important;
  }

  .table-report-container .report-card > div[style*="display: flex"] > div[style*="width: 280px"],
  .table-report-container .report-card > div[style*="display: flex"] > div[style*="width: 320px"] {
    width: 100% !important;
  }

  .table-report-container .report-card > div[style*="padding: 0 24px"] {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  /* Legend / priority chips that use inline flex rows */
  .table-report-container .report-card > div[style*="display: flex"][style*="gap"] {
    flex-wrap: wrap !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/bi-report/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iDAAiD;EACjD,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;;IAEE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,6DAA6D;EAC7D;IACE,iCAAiC;EACnC;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA,sDAAsD;EACtD;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".bi-report-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f5f5;\n  padding: 20px;\n}\n\n.bi-report-header {\n  margin-bottom: 20px;\n}\n\n.bi-report-header h1 {\n  color: #333;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.tab-navigation {\n  display: flex;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  margin-bottom: 0;\n}\n\n.bi-report-content {\n  flex: 1;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  overflow: hidden;\n}\n\n.tab-button {\n  flex: 1;\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border: none;\n  border-right: 1px solid #ddd;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  transition: all 0.3s ease;\n}\n\n.tab-button:last-child {\n  border-right: none;\n}\n\n.tab-button:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n.tab-button.active {\n  background-color: #007bff;\n  color: white;\n  font-weight: 500;\n}\n\n.coming-soon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  font-size: 18px;\n  color: #666;\n  background-color: #f8f9fa;\n}\n\n/* TktsSLAsTable specific overrides */\n.table-report-container .chart-container {\n  width: 100%;\n  background-color: white;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n/* Chart and Loading Styles */\n.loading-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  background-color: #f8f9fa;\n}\n\n.loading-spinner {\n  font-size: 18px;\n  color: #666;\n  animation: pulse 1.5s ease-in-out infinite alternate;\n}\n\n@keyframes pulse {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.5;\n  }\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 5px;\n  font-style: italic;\n}\n\n/* Responsive design */\n@media (max-width: 1200px) {\n  .table-report-container .report-card > div[style*=\"display: flex\"] {\n    flex-direction: column;\n  }\n  \n  .table-report-container .report-card > div[style*=\"display: flex\"] > div:first-child {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding-right: 0;\n  }\n  \n  .table-report-container .report-card > div[style*=\"display: flex\"] > div:first-child > div {\n    flex: 1;\n    margin-right: 20px;\n  }\n}\n\n/* SLA Plotly chart */\n.sla-chart-section {\n  background-color: white;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n}\n\n.sla-plotly-card {\n  width: 100%;\n  min-height: 700px;\n  position: relative;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  border: 2px solid #e3f2fd;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.sla-plotly-wrap {\n  flex: 1;\n  min-height: 600px;\n  width: 100%;\n}\n\n.sla-chart-footer {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #e3f2fd;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #495057;\n  text-align: center;\n  font-weight: 500;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px 16px;\n}\n\n.sla-chart-empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 420px;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  border: 2px dashed #dee2e6;\n  margin: 20px 0;\n  padding: 24px 16px;\n}\n\n.sla-chart-refresh-btn {\n  padding: 12px 24px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.sla-chart-refresh-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Resource effectiveness / bi-report shared mobile helpers */\n.consultant-table-footer {\n  padding: 16px 24px;\n  background-color: #f8f9fa;\n  border-top: 2px solid #495057;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.consultant-table-footer-stats {\n  color: #495057;\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.consultant-chart-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1200;\n  padding: 20px;\n}\n\n.consultant-chart-modal {\n  background-color: white;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 90vw;\n  max-height: 90vh;\n  width: 800px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  overflow: auto;\n  box-sizing: border-box;\n}\n\n.consultant-chart-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e5e7eb;\n  gap: 12px;\n}\n\n.bi-split {\n  display: flex;\n  gap: 24px;\n  padding: 0 24px;\n}\n\n.bi-split-aside {\n  width: 280px;\n  flex-shrink: 0;\n}\n\n.bi-table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .bi-report-container {\n    padding: 12px;\n  }\n\n  .bi-report-header h1 {\n    font-size: 1.25rem;\n  }\n\n  .tab-navigation {\n    flex-wrap: wrap;\n  }\n\n  .tab-button {\n    padding: 8px 10px;\n    font-size: 12px;\n    flex: 1 1 45%;\n    border-right: 1px solid #ddd;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .data-table {\n    font-size: 12px;\n  }\n\n  .data-table th,\n  .data-table td {\n    padding: 8px 6px;\n  }\n\n  .sla-plotly-card {\n    min-height: 0;\n    padding: 12px;\n    border-radius: 10px;\n  }\n\n  .sla-plotly-wrap {\n    min-height: 320px;\n    height: min(52vh, 380px);\n  }\n\n  .sla-chart-footer {\n    font-size: 10px;\n    text-align: left;\n    justify-content: flex-start;\n  }\n\n  .sla-chart-empty {\n    min-height: 280px;\n    margin: 8px 0;\n  }\n\n  .consultant-table-footer {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px 14px;\n  }\n\n  .consultant-table-footer-stats {\n    gap: 8px 12px;\n    width: 100%;\n  }\n\n  .consultant-chart-modal-overlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .consultant-chart-modal {\n    width: 100%;\n    max-width: none;\n    max-height: 92dvh;\n    border-radius: 16px 16px 0 0;\n    padding: 16px;\n  }\n\n  .consultant-chart-modal-header {\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .consultant-chart-modal-header h3 {\n    font-size: 1rem !important;\n    word-break: break-word;\n  }\n\n  .consultant-chart-body {\n    height: min(320px, 42vh) !important;\n  }\n\n  .resource-effectiveness-consultant-container .table-report-container .report-header,\n  .resource-effectiveness-consultant-container .table-report-container [style*=\"padding: 0 24px\"] {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n\n  .resource-effectiveness-consultant-container .report-header {\n    padding: 14px 12px !important;\n  }\n\n  .bi-split {\n    flex-direction: column;\n    padding: 0 12px;\n    gap: 16px;\n  }\n\n  .bi-split-aside {\n    width: 100% !important;\n  }\n\n  .bi-split[style*=\"minHeight\"] {\n    min-height: 0 !important;\n  }\n\n  /* Override legacy inline bi-report flex sidebars on mobile */\n  .table-report-container .report-card > div[style*=\"display: flex\"] {\n    flex-direction: column !important;\n  }\n\n  .table-report-container .report-card > div[style*=\"display: flex\"] > div[style*=\"width: 280px\"],\n  .table-report-container .report-card > div[style*=\"display: flex\"] > div[style*=\"width: 320px\"] {\n    width: 100% !important;\n  }\n\n  .table-report-container .report-card > div[style*=\"padding: 0 24px\"] {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n\n  /* Legend / priority chips that use inline flex rows */\n  .table-report-container .report-card > div[style*=\"display: flex\"][style*=\"gap\"] {\n    flex-wrap: wrap !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
